import { amountPayOutInputName } from '@dekafvv/sharedfrontend';
import type { TAnswers, TPayOutState } from './types';

export const intialAnswers: TAnswers = {
    amounts: {
        [amountPayOutInputName]: '',
    },
};

export const initialPayOutState: TPayOutState = {
    answers: intialAnswers,
    portfolio: null,
    validations: {
        MinPortfolioValue: '0',
        MinimumValue: '0',
    },
    iban: '',
    exAntePayOut: {
        exAnteCostId: '',
        zeroCostStatement: true,
    },
    pendingOrdersAmount: 0,
};
